import React, { useState } from 'react'
import { deleteUser } from "@api";
import { useUser } from "@auth/UserContext";
import { Modal, Button } from "@components";
import { toast } from "@components/toast/Toast";
import TeamMemberForm from '../forms/TeamMemberForm';
import { useForm } from 'react-hook-form';

const DeleteTeamMember = ({open, onClose, onComplete, user}) => {

  const [loading, setLoading] = useState(false)

  const onSubmit = async () => {
    setLoading(true);
    const response = await deleteUser(user.id);
    setLoading(false);

    if (response.status === 204) {
      toast({ description: `Deleted "${user.name}" as a team member` });
      onComplete()
      onClose()
    }
  };

  return (
    <Modal isOpen={open} onClose={onClose} title="Add team member" size="sm">
      <div className="p-5">
        <p>Are you sure you want to delete {user.name}?</p>
        <p>You can restore the user at a later date by adding them with the same email address.</p>
      </div>
      <div className="p-4 flex gap-2 justify-end border-t">
        <Button onClick={onClose} disabled={loading} color="secondary">Cancel</Button>
        <Button 
          type="submit" 
          onClick={() => onSubmit()} 
          color="danger" 
          submitting={loading}
        >Delete team member</Button>
      </div>
    </Modal>
  )
}

export default DeleteTeamMember